<sc-padding [fitHeight]="true" class="scan-numberplate-dialog">
    <sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
        <sc-sub-title>{{'Kameras'| translate:['tmc-yard.ui.scan-numberplate.cameras', translationService.language]}}</sc-sub-title>
        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
        <sc-flex-fitting-content [vertical]="true">
            <div class="cameras">
                <sc-bordered-tile class="camera" [style]="selected === camera ? 'selected' : 'default'"
                    *ngFor="let camera of cameras" (click)="selectCamera(camera)">
                    <sc-padding>
                        <sc-flex>
                            <sc-icon iconClass="fa-camera-cctv"></sc-icon>
                            <sc-content-spacer></sc-content-spacer>
                            {{camera.name}}
                        </sc-flex>
                    </sc-padding>
                </sc-bordered-tile>
                <div *ngIf="cameras?.length == 0">
                    <sc-padding>{{'no data available' | translate: ['shared.tmc-table.nodata', translationService.language]}}</sc-padding>
                </div>
            </div>
        </sc-flex-fitting-content>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <sc-flex>
            <button mat-stroked-button [disabled]="selected == null" (click)="scanNumberplate()">
                {{'Kennzeichen scannen'| translate:['tmc-yard.ui.scan-numberplate.action.scan-numberplate', translationService.language]}}
            </button>
        </sc-flex>
    </sc-flex>
</sc-padding>
